export * from './notification.mappings'
export * from './injection-tokens'

export const NOTIFICATIONS_HISTORY_PULL_LIMIT = 14
